export const FEATURE_FLAG = {
  cookieName: '_bh_ffs',
};

export const LAUNCHDARKLY_USERID = {
  cookieName: '_bh_lduid',
  expires: 63072000000, // 2 years in ms
};
